import { Component, Input, Output, EventEmitter, ElementRef, ViewChild } from '@angular/core';
import { PlotlyModule } from 'angular-plotly.js';
import { PlotLegendComponent } from '../../plot-legend/plot-legend.component';
import { MatMenuModule } from '@angular/material/menu';
import { MatIconModule } from '@angular/material/icon';
import { AllDataModel, AllDataRow } from '../../models/all-data.model';
import { InsightsChartType } from '../../models/insights-chart.model';
import { PlotlyPlot } from '../../models/plots/plotly-plot.model';
import { PlotLegendData } from '../../models/plot-legend-data.model';
import { DownloadAsPngData } from '../../models/download-as-png-data.model';
import { DownloadAsCsvData } from '../../models/download-as-csv-data.model';

@Component({
  standalone: true,
  selector: 'app-piechart-plot',
  imports: [PlotlyModule, PlotLegendComponent, MatMenuModule, MatIconModule],
  templateUrl: './piechart-plot.component.html',
  styleUrls: ['./piechart-plot.component.scss'],
})
export class PieChartPlotComponent<T> {
  @ViewChild('chartCapture', { static: false }) private chartCapture?: ElementRef<HTMLElement>;

  @Input({ required: true }) plotlyData!: PlotlyPlot<T>;
  @Input({ required: true }) legendData!: PlotLegendData[];
  @Input({ required: true }) chartType!: InsightsChartType;
  @Input({ required: true }) plotLabel!: string;
  @Input({ required: true }) allData!: AllDataRow[];

  @Output() downloadPng = new EventEmitter<DownloadAsPngData>();
  @Output() downloadCsv = new EventEmitter<DownloadAsCsvData>();
  @Output() allDataClick = new EventEmitter<AllDataModel>();

  protected downloadAsPng(): void {
    if (!this.chartCapture) {
      return;
    }

    this.downloadPng.emit({
      chartType: this.chartType,
      captureElement: this.chartCapture.nativeElement,
    });
  }

  protected allDataClicked(): void {
    this.allDataClick.emit({
      title: this.plotLabel,
      chartType: this.chartType,
      subTitle: 'Incidents by ' + this.plotLabel,
      labelColumnName: this.plotLabel,
      excludeColumns: ['aggregation'],
      data: this.allData,
    });
  }

  protected downloadAsCsv(): void {
    this.downloadCsv.emit({
      chartType: this.chartType,
      labelColumnName: this.plotLabel,
      data: this.allData,
    });
  }
}
